import React from "react";
import { Box, Grid } from "@mui/material";
import ReportCardRow from "./ReportCardRow";
import { useTranslation } from "react-i18next";
import ErrorHandler from "../../components/ErrorHandler/ErrorHandler";
import Loader from "../../components/Loader/Loader";
import { useMemo } from "react";
// Imports Images
import NoSavedReport from "../../../assets/images/NoSavedReport.svg";

const ReportCard = (props) => {
  const { t } = useTranslation();
  const {
    data = { status: "success", message: "", data: [] },
    reloadFlag = true,
    onReload = () => {},
    reportType = "",
    user,
    onToggle,
    onClick,
    searchQuery = "",
    activeReport,
    setActiveReport,
    reloadData,
  } = props;

  const noDataMessageMapping = {
    saved: "No saved reports to display",
    scheduled: "No scheduled reports to display",
    download: "No downloads",
  };
  const noDataMessage = noDataMessageMapping[reportType];
  const filteredData = useMemo(() => {
    if (!searchQuery.trim()) return data.data;

    const lower = searchQuery.toLowerCase();
    return data.data.filter((item) =>
      item.title?.toLowerCase().includes(lower)
    );
  }, [searchQuery, data.data]);

  return (
    <div className={`reports-sidenav ${data.status} ${reportType}`}>
      {data.status === "loading" && <Loader />}
      {data.status === "error" && (
        <ErrorHandler
          message={data.message}
          reloadFlag={reloadFlag}
          onReload={onReload}
        />
      )}
      {data.status === "success" && filteredData.length === 0 && (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="400px"
          width="100%"
        >
          <img
            src={NoSavedReport} 
            alt="No reports found"
            style={{ width: 300, height: "auto", marginBottom: 16 }}
          />
          <p className="no-data">{t(noDataMessage)}</p>
        </Box>
      )}
      {data.status === "success" && filteredData.length !== 0 && (
        <Box className="report-grid-wrapper" px={3} py={2}>
          <Grid container spacing={2}>
            {filteredData.map((report) => (
              <ReportCardRow
                key={report.id}
                {...report}
                report={report}
                reportType={reportType}
                user={user}
                onToggle={onToggle}
                onClick={onClick}
                activeReport={activeReport}
                setActiveReport={setActiveReport}
                reloadData={reloadData}
              />
            ))}
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default ReportCard;
